import layoutHeaderAside from '@/layout/header-aside';
import accountInfo from '@/pages/accountInfo/index';

const meta = {auth: true};

export default {
    path: '/accountManage',
    name: 'accountManage',
    redirect: { name: 'account-manage-accountInfo' },
    component: layoutHeaderAside,
    meta: meta,
    children: (pre => [
        { 
            path: 'accountInfo', 
            name: `${pre}accountInfo`, 
            component: accountInfo, 
            meta: { 
                ...meta, 
                title: '账号信息' 
            } 
        }
    ])('account-manage-')
}